// Imports ------------------------------------------------------------------->

import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {i18n} from "../../i18n/I18n";

// Private Definitions ------------------------------------------------------->

// Public Definitions -------------------------------------------------------->

/* This is to work around a problem where we need to embed DECORATED spans within a translated string yet
	* still take advantage of JSX.
	* The Landing page uses strings where sections of text that are to be decorated (emphasized bold) are wrapped with
	*   {#n}my text{/b}
	* Where n is an integer representing the current link in the string
	* eg real string on Landing Page:
	*   "{#1}Seamlessly sync{\\1} your list to share."  (NOTE: 'Seamlessly sync' substring will be bold).
	*
	* This component parses that string and generates JSX with decorated spans substitued as required.
	*/

type LinkMap = {[key: number]: string};

interface I18nSpanProps {
	key: string;
	// TODO: Automatically JSON.stringify everywhere this is used
	values: LinkMap;
}

@element("flipp-i18n-span")
export class I18nSpan extends Component<I18nSpanProps, LinkMap> {

	@attr key: string;
	@attr values: string;

	prepare() {
		return JSON.parse(this.values) as LinkMap;
	}

	render(links: LinkMap) {

		const regex = /\{#\d\}(.*?)\{\\\d\}/g;
		const text = i18n(this.key);
		const matches = text.match(regex);

		if (!text) {
			return null;
		}

		if (!matches) {
			return <span>{text}</span>;
		}

		return <div>
			{matches.map((match, idx) => {
				if (idx === 0) {
					return <span>
						{text.substring(0, text.indexOf(match))}
						<span class={links[idx + 1]}>{match.substring(4, match.length - 4)}</span>
						{matches.length === 1 ?
							<span>{text.substring(text.indexOf(match) + match.length, text.length)}</span>
						: null
						}
					</span>;
				} else {
					return <span>
						{text.substring(text.indexOf(matches[idx - 1]) + matches[idx - 1].length, text.indexOf(match))}
						<span class={links[idx + 1]}>{match.substring(4, match.length - 4)}</span>
						{matches.length === (idx + 1) ?
							<span>{text.substring(text.indexOf(match) + match.length, text.length)}</span>
						:
							null
						}
					</span>;
				}
			})}
		</div>;

	}
}
